import { BenefitDetailResponse } from '@aslanpay/portal-common-lib';

import { AddEditBenefitFormFields } from './AddEditBenefitForm.types';

function convertBenefitToFormData(benefit: BenefitDetailResponse): AddEditBenefitFormFields {
  return {
    benefitName: benefit.name,
    shortDescription: benefit.shortDescription || '',
    description: benefit.description || '',
    employeeLink: benefit.linkUrl || '',
    linkName: benefit.linkName || '',
    logoUrl: benefit.logoUrl || '',
    categoryIds: benefit.categories?.map((category) => category.id) ?? [],
    highlights:
      benefit.highlights.length > 0
        ? benefit.highlights?.map((highlight) => ({ text: highlight.text }))
        : [],
    eligibilityCriteria:
      benefit.eligibilityCriteria?.length > 0
        ? benefit.eligibilityCriteria.map((criterion) => ({ text: criterion.text }))
        : [],
    images: benefit.images?.map((image) => ({ imageUrl: image.imageUrl })) ?? [],
    videoUrls: benefit.videoUrls?.map((url) => ({ url: url.url })) ?? [],
    faqs:
      benefit.faqs.length > 0
        ? benefit.faqs?.map((faq) => ({
            question: faq.question,
            answer: faq.answer,
          }))
        : [],
    links: benefit.links?.map((l) => ({ linkUrl: l.linkUrl, linkName: l.linkName })) ?? [],
    documents: (benefit.documents ?? [])
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .map((d) => ({
        id: d.id,
        fileUploadId: d.fileUploadId,
        displayName: d.displayName,
        fileName: '',
      })),
  };
}

export default convertBenefitToFormData;
